// Event-feature capability checks, mirroring the backend `occasion` capability
// map. The backend attaches a `capabilities` array (e.g. ["rsvp","seating"]) to
// every aura/site payload, so the frontend never hardcodes the occasion→feature
// mapping.
//
// Backward-safe: a payload WITHOUT `capabilities` (older cached response, or an
// endpoint that predates this field) is treated as supporting everything, so we
// never hide a feature by accident.
export function supportsCapability(obj, cap) {
  return !obj?.capabilities || obj.capabilities.includes(cap);
}
